import { Redirect } from 'expo-router';

import { LoyaltyRewardsListWidget as LoyaltyRewardsListItemPage } from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-widgets/loyalty-rewards-list-widget';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function RewardsItemPage() {
  const enableRewardsTiers = useFlag(LaunchDarklyFlag.ENABLE_REWARDS_TIERS) as boolean;

  if (enableRewardsTiers) {
    return <Redirect href={routes.offersV2} />;
  }

  return <LoyaltyRewardsListItemPage />;
}
